const entities = {
  fieldLibrary: "Field Library",
  fieldLibraryDesc: "Global reusable fields across all entities",
  entityTypes: "Entity Types",
  entityTypesDesc: "Templates defining which fields to show for each note type",
  newField: "New Field",
  editField: "Edit Field",
  newType: "New Type",
  editType: "Edit Type",
  metaKey: "Meta Key",
  fieldType: "Field Type",
  category: "Category",
  composite: "Composite",
  subFields: "Sub-fields",
  addSubField: "Add sub-field",
  displayTemplate: "Display Template",
  options: "Options",
  addOption: "Add option",
  label: "Label",
  labelHe: "Label (Hebrew)",
  labelEn: "Label (English)",
  fields: "fields",
  usedIn: "Used in",
  allCategories: "All Categories",
  allTypes: "All Types",
  searchFields: "Search fields...",
  searchTypes: "Search entity types...",
  noFieldsFound: "No fields found",
  cancel: "Cancel",
  save: "Save",
  create: "Create",
  slug: "Slug",
  icon: "Icon",
  color: "Color",
  defaultView: "Default View",
  registryKind: "Registry Kind",
  registryKindHint: "מאגר (registry) = operational record, created/edited here · ספריה (library) = design-system component · קטלוג (catalog) = external reference list, read-only",
  registryKindOptions: { "מאגר": "מאגר — Operational record", "ספריה": "ספריה — Design-system component", "קטלוג": "קטלוג — External reference list (read-only)" },
  selectFields: "Select Fields",
  inheritedFrom: "inherited from ",
  inheritedFieldsHint: "Fields marked «inherited» come from the parent type and are not stored on this type",
  selectGroups: "Select Repeating Groups",
  connections: "Connections",
  sourceType: "Source",
  targetType: "Target",
  relationLabel: "Relation label",
  add: "Add",
  viewNotes: "View notes",
  views: { table: "Table", board: "Board", list: "List", calendar: "Calendar", gantt: "Gantt", timeline: "Timeline", gallery: "Gallery", stream: "Stream" },
  searchNotes: "Search notes...",
  newNote: "New Note",
  records: "records",
  filter: "Filter",
  contains: "Contains",
  isEmpty: "Is empty",
  isNotEmpty: "Is not empty",
  addFilter: "Add filter",
  prev: "Previous",
  next: "Next",
  loading: "Loading...",
  entityNotFound: "Entity type not found",
  versionConflict: "Not saved — the record may have changed since it was opened. Data refreshed, try again",
  linkedNotes: "Linked Notes",
  link: "Link",
  searchToLink: "Search note to link...",
  stakeholders: "Stakeholders",
  addStakeholder: "Add stakeholder",
  searchContact: "Search contact...",
  primary: "Primary",
  additional: "Additional",
  access: "Access",
  notify: "Notify",
  role: "Role",
  activity: "Activity",
  comment: "Comment",
  callLog: "Call",
  showInactive: "Show inactive",
  hideInactive: "Hide inactive",
  deactivate: "Deactivate",
  reactivate: "Reactivate",
  inactive: "Inactive",
  zoom: "Zoom",
  day: "Day",
  week: "Week",
  month: "Month",
  noGanttData: "No data for Gantt view",
  noTimelineData: "No data for timeline view",
  devTask: "Dev Task",
  deal: "Deal",
  lead: "Lead",
  agreement: "Agreement",
  kpiEvents: "KPI Events",
  activityLog: "Activity Log",
  backToList: "Back to list",
  lastEdited: "Last edited",
  createdAt: "Created",
  confirmDelete: "Delete permanently?",
  actions: {
    allActions: "All actions",
    deactivate: "Deactivate",
    reactivate: "Reactivate",
    changeStatus: "Change Status",
    exportCsv: "Export CSV",
    openInAi: "Open in AI",
    sendNotification: "Send Notification",
    callLog: "Call Log",
    sendWhatsapp: "Send WhatsApp",
    confirmDeactivate: "Deactivate this note?",
    confirmBulkDeactivate: "Deactivate selected notes?",
    bulkSelected: "selected",
    noActions: "No actions available",
    bulkStatusChange: "Bulk Status Change",
    bulkAssignTitle: "Bulk Assign",
    assigneePlaceholder: "Assignee name...",
    applyAssign: "Apply Assignment",
    noStatusOptions: "No status options",
  },
  bulk: {
    title: "Bulk Field Update",
    stepField: "Select Field",
    stepValue: "Set Value",
    stepPreview: "Preview",
    settingValueFor: "Setting value for",
    next: "Next",
    apply: "Apply Changes",
    recordsAffected: "records will be affected",
    record: "Record",
    currentValue: "Current",
    newValueLabel: "New Value",
    more: "more",
  },
  saveFailed: "Save failed",
  tabGeneral: "General",
  tabTemplate: "Template",
  templates: "Templates",
  addTemplate: "Add template",
  browseTemplates: "Browse templates",
  linkedTemplates: "Linked Templates",
  openFullEditor: "Open in editor",
  noTemplates: "No templates",
  linkTemplate: "Link template",
  unlinkTemplate: "Unlink",
  createTemplate: "Create new template",
  accessDenied: "Access denied",
  adminOnly: "This action is restricted to admins",
  roleAdmin: "Admin",
  roleManager: "Manager",
  roleMember: "Member",
  roleViewer: "Viewer",
  roleExternal: "External",
  savedViews: "Saved Views",
  saveView: "Save View",
  viewName: "View name",
  deleteView: "Delete view",
  noSavedViews: "No saved views",
  savedViewPrivate: "Only me",
  savedViewsLoadFailed: "Could not load saved views",
  viewSaveFailed: "Could not save view",
  viewDeleteFailed: "Could not delete view",
  viewSaved: "View saved",
  viewDeleted: "View deleted",
  allRecords: "All records",
  aliases: "Aliases",
  addAlias: "Add alias",
  noAliases: "No aliases",
  mergeField: "Merge into field",
  mergeWarning: "Old meta_key becomes an alias — existing data won't break",
  autoGenerated: "Auto-generated",
  aliasSource: "Source",
  aliasManual: "Manual",
  aliasMerged: "Merged",
  fieldMerged: "Field merged successfully",
  groupByCategory: "Group by Category",
  flatList: "Flat List",
  confirmDeleteField: "Delete this field?",
  fieldUsedWarning: "This field is in use. Deleting may cause data loss",
  tryDifferentSearch: "Try different search terms",
  noFieldsYet: "No fields yet",
  createFirstField: "Create first field",
  validation: "Validation",
  required: "Required",
  uniqueValue: "Unique value",
  patternRegex: "Pattern (Regex)",
  defaultValue: "Default Value",
  noDefault: "No default",
  dragToReorder: "Drag to reorder",
  descriptionHe: "Description (Hebrew)",
  descriptionEn: "Description (English)",
  clientDisplayNameHe: "Client Display Name (Hebrew)",
  clientDisplayNameEn: "Client Display Name (English)",
  clientDisplayNameHint: "The name clients will see in forms and their personal area. Default: field name",
  storyCardRefs: "Story Cards",
  noStoryCardRefs: "No linked story cards",
  viewInStoryMap: "View in Story Map",
  systemFields: "System Fields",
  systemField: "System Field",
  systemFieldLocked: "System field — cannot be deleted",
  universalFields: "Universal Fields",
  valuesWithoutField: "Values with no field",
  viewCards: "Cards",
  viewList: "List",
  viewCompact: "Table",
  fieldInfo: "Field Info",
  fieldPurpose: "Purpose",
  fieldUsage: "Usage",
  fieldSettings: "Settings",
  optionsCount: "Options",
  hasValidation: "Validation",
  hasColorRules: "Color Rules",
  hasVisibilityRules: "Visibility Rules",
  isReadOnly: "Read Only",
  noDescription: "No description",
  totalFields: "Total fields",
  searchByAll: "Search by name, key, description, category...",
  tabSystem: "System Fields",
  tabLibrary: "Field Library",
  systemFieldsInfo: "System fields are built-in and automatically applied to every entity. They cannot be deleted or edited.",
  libraryFieldsInfo: "Create new fields and manage your library here. These fields are available for selection when building entity types.",
  tips: {
    validation: "Validation = data rules. Defines whether the field is required, must be unique (no duplicates), and what format is expected.",
    required: "Required = must have a value. The note cannot be saved without filling this field.",
    unique: "Unique value = the same value cannot appear twice. E.g.: ID number, invoice number.",
    pattern: "Pattern (Regex) = specific format the value must match. E.g.: Israeli phone number, email address.",
    minMax: "Min / Max = allowed range for the value. For numbers: numeric value. For text: minimum/maximum character length.",
    metaKey: "Meta key = technical field identifier in the DB. Auto-generated from the name. Used for data binding.",
    fieldType: "Field type determines what kind of data can be entered: free text, number, dropdown selection, date, etc.",
    category: "Category = logical grouping of fields. Helps find fields quickly and filter by topic.",
    composite: "Composite field = contains sub-fields inside it. E.g.: full address with street, city, zip code.",
    options: "Options = list of possible choices for a select field. Each option has a name and color.",
    aliases: "Aliases = alternative keys pointing to the same field. Useful when merging fields or importing data.",
    visibilityRules: "Visibility rules = when to show the field. E.g.: show 'Close reason' only when status = 'Closed'.",
    colorRules: "Color rules = dynamic background color based on value. E.g.: red when vacation days < 3, green when completion > 70%.",
    readOnly: "Read-only = field is displayed but cannot be manually edited. Updated automatically by the system.",
    defaultValue: "Default value = the value that will be auto-filled when creating a new note.",
    description: "Description = explanation of what the field does and what it's used for. Shown in field info.",
    icon: "Icon = visual symbol representing the field. Shown next to the field name in forms and tables.",
    merge: "Merge = combine two fields into one. The old key becomes an alias, existing data is preserved.",
    sortOrder: "Sort order = the field's position in the list. Can be changed by dragging.",
    entityType: "Entity type = a 'lens' that defines which fields to show. The same note can look different in each type.",
    templateConfig: "Template = advanced settings: layout, available views, board/gantt config, action buttons.",
    connections: "Connections = relationships between entity types. E.g.: client → property, vendor → invoice.",
    fieldGroups: "Repeating groups = a collection of fields that repeats. E.g.: call log, payment log.",
  },
  activityLabels: { field_change: "Field changed", status_change: "Status changed", comment: "Comment", call_log: "Call", relation_added: "Relation added", relation_removed: "Relation removed", stakeholder_added: "Stakeholder added", stakeholder_removed: "Stakeholder removed", created: "Created", deactivated: "Deactivated", reactivated: "Reactivated", deleted: "Deleted" },
  timeNow: "now",
  timeMinutesAgo: "{n}m ago",
  timeHoursAgo: "{n}h ago",
  timeDaysAgo: "{n}d ago",
  addCommentPlaceholder: "Add comment...",
  callSummaryPlaceholder: "Call summary...",
  noActivityYet: "No activity yet",
  comments: { title: "Comments", reply: "Reply", edit: "Edit", delete: "Delete", edited: "(edited)", deleteConfirm: "Sure to delete?", writeComment: "Write a comment...", noComments: "No comments yet", replyingTo: "Replying to...", justNow: "now", reactions: "Reactions" },
  notifyAll: "All",
  notifyMilestones: "Milestones",
  notifyMentions: "Mentions",
  notifyNone: "None",
  noStakeholdersYet: "No stakeholders yet",
  tabOptions: "Options",
  tabValidation: "Validation",
  tabVisibility: "Visibility",
  tabColors: "Colors",
  tabAliases: "Aliases",
  readOnlyField: "Read-only field",
  visibilityRulesLabel: "Visibility Rules",
  visibilityRulesDesc: "Field shown only when all conditions are met. Hidden required fields are not enforced.",
  addCondition: "Add rule",
  fieldAlwaysVisible: "Field always visible (no conditions)",
  valuePlaceholder: "Value",
  colorRulesLabel: "Color Rules",
  colorRulesDesc: "Field color changes based on conditions. First matching rule wins.",
  addColorRule: "Add rule",
  noColorRules: "No color rules (default styling)",
  addRow: "Add row",
  setupGuide: "Entity Setup Guide",
  stepByStep: "Step by step",
  openLink: "Open",
  templateNamePlaceholder: "Template name...",
  noTimelineDataDisplay: "No data for timeline view",
  noStreamDataDisplay: "No activity yet",
  noDateFieldDefined: "No date field defined for this entity",
  tabGeneralType: "General",
  tabTemplateType: "Template",
  titleColumn: "Title",
  noRecords: "No records",
  noGanttDataDisplay: "No data for Gantt view",
  ganttZoom: "Zoom",
  ganttDay: "Day",
  ganttWeek: "Week",
  ganttMonth: "Month",
  boardAll: "All",
  boardNone: "None",
  boardHideEmpty: "Hide empty columns",
  columnBrowser: "Column browser",
  noStatusFieldFound: "No status field found",
  callSummaryActionPlaceholder: "Call summary...",
  noConnectionsDefined: "No connections defined",
  connectionDiagram: "Connection Diagram",
  linksCount: "links",
  relations: "Relations",
  addRelation: "Add relation",
  searchToLinkRelation: "Search entity to link...",
  noRelations: "No relations yet",
  removeRelation: "Remove relation",
  linkedEntities: "Linked Entities",
  bulkBar: {
    nSelected: "selected",
    updateStatus: "Update Status",
    updateField: "Update Field",
    deactivate: "Deactivate",
    delete: "Delete",
    confirmDelete: "Delete the selected notes?",
    confirmDeactivate: "Deactivate the selected notes?",
    apply: "Apply",
    success: "Action completed successfully",
    selectField: "Select field",
    enterValue: "Enter value...",
    partial: "{ok} done, {failed} failed",
    allFailed: "Action failed — no records changed",
  },
  entityCanvas: {
    frame: "Frame",
    linkGraph: "Link Graph",
    navLog: "Nav Log",
    addBlock: "Add Block",
    emptyCanvas: "Drag blocks here — folders, fields, groups, plugins",
    emptyGraph: "Entity link graph will display here",
    emptyHistory: "No navigation history yet",
    noRelations: "No relations yet",
    title: "Title",
    type: "Type",
    time: "Time",
    newBlock: "New Block",
    folder: "Folder",
    field: "Field",
    fieldGroup: "Field Group",
    note: "Note",
    plugin: "Plugin",
    pickBlockType: "Pick block type",
    pickField: "Pick field",
    comingSoon: "Coming soon",
    linkedEntities: "Linked entities",
    noLinked: "No linked entities",
    whiteboard: "vCanvas",
  },
  csvImport: {
    importCsv: "Import CSV",
    uploadTitle: "Upload CSV",
    uploadDesc: "Drag a CSV file here or click to browse",
    dropHere: "Drop file here",
    browse: "Browse",
    fileSelected: "File selected",
    rowCount: "rows",
    mapFields: "Map Fields",
    csvColumn: "CSV Column",
    entityField: "Entity Field",
    skipColumn: "-- Skip --",
    autoMapped: "Auto-mapped",
    preview: "Preview",
    importButton: "Import",
    importing: "Importing...",
    importComplete: "Import completed successfully",
    importError: "Import error",
    step1: "Upload",
    step2: "Map",
    step3: "Import",
  },
} as const;
export default entities;
